import { Component, Input, HostBinding } from '@angular/core';


@Component({
  selector: 'app-tab-pane',
  standalone: true,
  imports: [],
  templateUrl: './tab-pane.component.html',
  styleUrls: ['./tab-pane.component.scss']
})
export class TabPaneComponent {
  // Required ID to link with the tab header
  @Input({ required: true }) id!: string;
  // Label to be shown in the header
  @Input() label!: string;
  // Optional disabled state
  @Input() disabled = false;

  // Managed by TabsComponent to toggle visibility
  @HostBinding('class.hidden') hidden = false;
}
